export { default } from './Tabs/Tab'
